function t(t){const n=t.documentElement.clientWidth;return Math.abs(window.innerWidth-n)}export{t as default};
//# sourceMappingURL=getScrollbarSize.js.map
